<template>
  <div class="mini-hero-form">
    <div class="grid-x grid-margin-x">
      <div class="cell large-4 mini-hero-form__container">
        <h1 class="editorial__title text--heading-l">{{ miniHeroFormTitle }}</h1>
        <div class="editorial__text text--body">
          <p>{{ miniHeroFormDescription }}</p>
        </div>
        <form v-if="precompiledSet">
          <b-form-group :label="$msg('common.form.is-business.label.text')"
                        :class="brandFormType === 'allCustomers' ? '' : 'd-none'" v-if="brandFormType === 'allCustomers'">
            <b-form-radio v-model="form.isBusiness" name="isBusiness"
                          :value="false" @change="removeIndustry">
              <msg
                id="common.form.private.label.text"
                :bare="true"
              />
            </b-form-radio>
            <b-form-radio v-model="form.isBusiness" name="isBusiness"
                          :value="true" @change="removeLastName">
              <msg
                id="common.form.corporate.label.text"
                :bare="true"
              />
            </b-form-radio>
          </b-form-group>
          <b-form-group
            :id="`fieldset-first-name`"
            :label="createString(firstNameLabel, false)"
            label-for="first-name-1"
          >
            <b-form-input
              type="text"
              id="first-name-1"
              :aria-required="false"
              v-model="form.firstName"
              lazy
            ></b-form-input>
          </b-form-group>
          
          <b-form-group
            v-if="form.isBusiness"
            :id="`industry-group`"
            :label="createString('industry', false)"
            label-for="industry"
          >
            <div class="form-select">
              <b-form-select
                v-model="form.businessIndustry"
                :options="options(optionBusinessIndustry, 'industry')"
                id="industry"
                :aria-required="false"
              ></b-form-select>
            </div>
          </b-form-group>
          
          <b-form-group
            v-if="!form.isBusiness"
            :id="`fieldset-last-name`"
            :label="createString('last-name', false)"
            label-for="last-name-1"
          >
            <b-form-input
              type="text"
              id="last-name-1"
              :aria-required="false"
              v-model="form.lastName"
              lazy
            ></b-form-input>
          </b-form-group>

        </form>
        <p v-if="ctaLinks" class="editorial__cta">
        <span v-for="(ctaObj, i) in integratedCtaLinks">
          <advanced-button-wrapper :cta-obj="ctaObj" color="primary" :styleType="i === 0 ? 'contained' : 'text'" size="medium"
                                   :analyticsData="analyticsData(ctaObj)"/>
        </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AdvancedButtonWrapper from "../Advanced-Button-Wrapper/Advanced-Button-Wrapper";
import {validationMixin} from "vuelidate";
import {minLength} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "MiniHeroForm",
  components: {
    AdvancedButtonWrapper,
  },
  data() {
    return {
      form: {
        isBusiness: null,
        firstName: "",
        lastName: "",
        businessIndustry: null
      },
      optionBusinessIndustry: [
        {value: null, text: ""},
        {value: "Constructions", text: ""},
        {value: "Waste and Recycling Services", text: ""},
        {value: "Public Administration", text: ""},
        {value: "Maintenance Services", text: ""},
        {value: "Logistics", text: ""},
        {value: "Gardening - Agricultural", text: ""},
        {value: "Food Industry", text: ""},
        {value: "Other", text: ""}
      ]
    };
  },
  props: {
    precompiledSet: {
      type: Boolean,
      default: false
    },
    miniHeroFormTitle: {
      type: String
    },
    miniHeroFormDescription: {
      type: String
    },
    ctaLinks: {
      type: Array,
      default: () => []
    },
    brandFormType: {
      type: String,
      default: "privateCustomers"
    },
  },
  inheritAttrs: false,
  /*
    validations() {
      const form = {
        "firstName": {
          minLength: minLength(2),
        },
        "lastName": {
          minLength: minLength(1),
        }
      };
      return {form};
    },
   */
  computed: {
    invalidFeedback() {
      return this.$msg(`common.form.validation.required-field.invalid.text`);
    },
    
    validFeedback() {
      return this.$msg(`common.form.validation.required-field.valid.text`);
    },
    
    isBusiness() {
      switch (this.brandFormType) {
        case 'privateCustomers':
          return 'first-name';
        case 'corporateCustomers':
          return 'corporate-name';
      }
    },
    
    firstNameLabel() {
      return this.form.isBusiness ? 'corporate-name' : 'first-name';
    },
    
    integratedCtaLinks() {
      return this.ctaLinks.map(ctaObj => {
        ctaObj['precompiledParameters'] = {};
        Object.keys(this.form).forEach(inputKey => ctaObj['precompiledParameters'][inputKey] = this.form[inputKey]);
        return ctaObj;
      });
    }
  },
  methods: {
    
    options(fieldOptions, fieldName) {
      // Replacing options from json with options built using translations
      let newOptions = [];
      
      fieldOptions.forEach((element, index) => {
        //console.log(index, element.value, element.text);
        let newOption = {};
        
        newOption.value = element.value;
        newOption.text = this.$msg(
          `common.form.${fieldName}.option.${index}.text`
        );
        
        newOptions.push(newOption);
      });
      
      //console.log("fieldOptions", fieldOptions);
      //console.log("newOptions", newOptions);
      return newOptions;
    },
    
    removeIndustry() {
      this.form.businessIndustry = null;
    },
    
    createString(fieldName, fieldMandatory) {
      let required = fieldMandatory
        ? this.$msg(`common.form.required.symbol.text`)
        : "";
      let label = this.$msg(`common.form.${fieldName}.label.text`);
      return label + required;
    },
    
    removeLastName() {
      this.form.lastName = null;
    },
    
    analyticsData(el) {
      return {
        evCategory: 'call_to_action',
        evAction: el.document?.url || el.link?.url || el.trackingLabel,
        evLabel: `${el.campaignId || 'No Campaign'} | ${this.actpageFullUrl}`
      }
    }
  },
  created() {
    this.form.isBusiness = this.brandFormType === 'corporateCustomers';
  }
};
</script>